import useAppContext from 'flow/hooks/useAppContext';
import { twMerge } from 'tailwind-merge';
import Loading from 'flow/components/ui-components/Loading';

interface Props {
    value: string | number;
    i18Key: string;
    className: string;
    isLoading?: boolean;
    hasStats?: boolean;
}

const AIStatsWidgetComponent = ({
    value,
    i18Key,
    className,
    isLoading,
    hasStats,
}: Props) => {
    const { i18next } = useAppContext();

    const renderCircle = () => {
        if (isLoading || !hasStats) {
            return (
                <div className="flex h-32 w-32 items-center justify-center rounded-full bg-gray-200 dark:bg-gray-200">
                    {isLoading ? (
                        <Loading
                            size={48}
                            disableTimeout={true}
                            className="grow-0"
                        />
                    ) : (
                        <div className="text-gray-400 dark:text-gray-500">
                            {'—'}
                        </div>
                    )}
                </div>
            );
        }

        return (
            <div
                className={twMerge(
                    'flex h-32 w-32 items-center justify-center rounded-full',
                    className,
                )}
            >
                <div className="font-bold text-gray-900 dark:text-white">
                    {value}
                </div>
            </div>
        );
    };

    return (
        <div className="flex max-w-1/5 flex-col items-center gap-2">
            <div className="text-center text-xs font-normal text-gray-600 dark:text-gray-800">
                {i18next.t(i18Key)}
            </div>
            {renderCircle()}
        </div>
    );
};

export default AIStatsWidgetComponent;
